import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import arrowImage from '../../assets/images/arrow-left.svg';
import css from './header.scss';

const handleOnClick = (backUrl) => {
    window.location = backUrl
};

const Header = ({ text = '', btnTxt = '', backUrl = undefined }) => (
    <div className={css.component}>
        {backUrl && <div className={css['btn-wrapper']}>
        <button
            className={css['back-button']}
            onClick={() => handleOnClick(backUrl)}
        >
            <img 
            className={css['btn-arrow']}
            src={arrowImage}
            alt='<<' 
            />
            {btnTxt}
        </button>
        </div>}
            <div className={css.mathleticslibrary}>{text}</div>
    </div>
);

Header.propTypes = {
    text: PropTypes.string.isRequired,
    btnTxt: PropTypes.string.isRequired,
    backUrl: PropTypes.string
};

export default Header;
